;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:localcoin":true});}catch(e){}}();import { ROUTES } from '@/routes';
import { Lang } from '@/types/locales';

export const getAlert = async (lang: Lang) => {
  const response = await fetch(ROUTES.alert(lang));

  if (!response.ok) {
    return null;
  }

  const alert = await response.json();

  return alert;
};

export const getAnnouncement = async (lang: Lang) => {
  const response = await fetch(ROUTES.announcement(lang));

  if (!response.ok) {
    return null;
  }

  const alert = await response.json();

  return alert;
};
